import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";

import { style } from "variables/Variables.jsx";

import dashboardRoutes from "routes/dashboard.jsx";
import { NotificationContainer } from "react-notifications";
import LoginComponent from "./Login";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.dummy = this.dummy.bind(this);

    this.state = {
      _notificationSystem: null,
      authenticated: false,
    };
  }

  dummy() {}

  handleNotificationClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: <div>به نرم افزار مدیریت خوش آمدید</div>,
      level: "success",
      position: position,
      autoDismiss: 15,
    });
  }
  componentWillMount() {
    if (localStorage.getItem("token")) {
      this.setState({ authenticated: true });
    }
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    if (!this.state.authenticated) {
      return <LoginComponent />;
    } else {
      return (
        <div className="wrapper">
          <NotificationSystem ref="notificationSystem" style={style} />
          <Sidebar {...this.props} />
          <div
            id="main-panel"
            className="main-panel"
            style={{ paddingBottom: "80px" }}
            ref="mainPanel"
          >
            {/* <Header {...this.props} /> */}
            <Switch>
              {dashboardRoutes.map((prop, key) => {
                if (prop.name === "Notifications")
                  return (
                    <Route
                      path={prop.path}
                      key={key}
                      render={(routeProps) => (
                        <prop.component
                          {...routeProps}
                          handleClick={this.dummy}
                        />
                      )}
                    />
                  );
                if (prop.redirect) {
                  return <Redirect from={prop.path} to={prop.to} key={key} />;
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
              <Redirect to="/" />
            </Switch>
            <Footer />
          </div>
          <NotificationContainer />
        </div>
      );
    }
  }
}

export default Dashboard;
